export const GET_MY_BRANDS = 'GET_MY_BRANDS';
export const ADD_TO_MY_BRAND = 'ADD_TO_MY_BRAND';
export const REMOVE_FROM_MY_BRAND = 'REMOVE_FROM_MY_BRAND';
export const REMOVE_FROM_MY_BRAND_MULTIPLE = 'REMOVE_FROM_MY_BRAND_MULTIPLE';
export const SET_IS_LOADING_GET_MY_BRANDS = 'SET_IS_LOADING_GET_MY_BRANDS';
export const CREATE_NEW_BRAND = 'CREATE_NEW_BRAND';
export const SET_POINTS_OF_SALE_CONNECTED = 'SET_POINTS_OF_SALE_CONNECTED';
export const SET_ADD_TO_MY_BRAND_MULTIPLE_STATUS = 'SET_ADD_TO_MY_BRAND_MULTIPLE_STATUS';
export const SET_IS_LOADING_ADD_TO_MY_BRAND = 'SET_IS_LOADING_ADD_TO_MY_BRAND';
export const EMAIL_RESEND = 'EMAIL_RESEND';
export const SET_IS_LOADING_RESEND_EMAIL_VERIFICATION = 'SET_IS_LOADING_RESEND_EMAIL_VERIFICATION';
